import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Home } from "../../../components/Public/Home/Home";
import { HomeModal } from "../../../components/Public/Home/HomeModal";
import { getValorParametroPruebas } from "../../../redux/aspirante/catalogoDucks";
import { MODO_PRUEBAS } from "../../../utils";

/**
 * Page del Home principal del portal público
 * @returns JSX.Element
 */
export const HomePage = () => {
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
  }, []);

  useEffect(() => {
    isMounted.current && dispatch(getValorParametroPruebas(MODO_PRUEBAS));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div style={{ marginBottom: 30 }}>
        <Home />
        <HomeModal />
      </div>
    </>
  );
};
